<template>
  <section class="bg-bg py-14 tablet:py-16">
    <div class="container">
      <div class="mb-8 flex flex-col items-center gap-2 text-center tablet:mb-10">
        <span class="text-[11px] font-bold uppercase tracking-[0.2em] text-gold-primary-120">{{
          t('landing.partners.eyebrow')
        }}</span>
        <h3 class="max-w-2xl text-[22px] font-bold tracking-tight text-black-100 tablet:text-[28px]">
          {{ t('landing.partners.title') }}
        </h3>
      </div>
      <div class="relative overflow-hidden">
        <div
          class="pointer-events-none absolute start-0 top-0 z-10 h-full w-16 bg-gradient-to-r from-bg to-transparent rtl:bg-gradient-to-l"
        ></div>
        <div
          class="pointer-events-none absolute end-0 top-0 z-10 h-full w-16 bg-gradient-to-l from-bg to-transparent rtl:bg-gradient-to-r"
        ></div>
        <div class="marquee-track flex whitespace-nowrap">
          <div
            v-for="(name, i) in loop"
            :key="i"
            class="mx-3 flex h-12 items-center rounded-xl border border-black/[0.06] bg-white px-5 font-display text-[13px] font-semibold tracking-[0.08em] text-black-80"
          >
            {{ name }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n();
const names = [
  'EMAAR',
  'DAMAC',
  'SOBHA',
  'NAKHEEL',
  'MERAAS',
  'ARADA',
  'AZIZI',
  'BINGHATTI',
  'ELLINGTON',
  'OMNIYAT',
  'DANUBE',
  'DEYAAR',
  'SELECT GROUP',
  'MAG',
  'DUBAI PROPERTIES',
  'TIGER',
  'SAMANA',
  'OBJECT 1',
  'IMKAN',
  'ALDAR',
];
const loop = [...names, ...names];
</script>

<style scoped lang="scss">
.marquee-track {
  animation: scroll 40s linear infinite;
  will-change: transform;
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
// RTL: the doubled row overflows to the left, so loop toward the right (as masterclass/Hero.vue).
[dir='rtl'] .marquee-track {
  animation-name: scroll-rtl;
}
@keyframes scroll-rtl {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(50%);
  }
}
</style>
